import React, { createContext, useContext, type ReactNode } from "react";

/** The user turn that produced the markdown being rendered, or null where
 *  there is no question to attribute (an artifact card, a subagent result
 *  preview, a standalone render).
 *
 *  It travels by context rather than by prop because MarkdownView's component
 *  overrides live in a module-scope const — they can't call hooks and can't
 *  close over render state, so anything they render has to read provenance
 *  from React context. */
const UserQuestionContext = createContext<string | null>(null);

export function UserQuestionProvider({
  question,
  children,
}: {
  question: string | null;
  children: ReactNode;
}) {
  // The value IS the scalar, so consumers are only invalidated when the
  // question itself changes — no memo, and no object identity to churn on
  // every streamed token.
  return (
    <UserQuestionContext.Provider value={question}>
      {children}
    </UserQuestionContext.Provider>
  );
}

export function useUserQuestion(): string | null {
  return useContext(UserQuestionContext);
}
